module.exports = __webpack_public_path__ + "static/lylli-icon-6ef36200896b661a41c63019bc30245a.png";